module.exports = __webpack_public_path__ + "img/新官網首頁圖_工作區域_1.1259c813.png";